module.exports = __webpack_public_path__ + "media/images/fanclub/kv-chara-02-e39bb6052f8c469bfd5bb7f5a3587cc1.png";